// ---- the UGC slider ----
// A looping carousel with centred slides, written by hand so the section
// carries no external library. The slides are cloned once before and once
// after the real set, and the index jumps back into the middle copy after
// every move, which is what makes the loop endless in both directions.
(function () {
  // one section can sit on a page more than once, and the theme editor
  // rebuilds it on every change
  function setup(root) {
    if (root.dataset.nextdevUgcInit) return;
    root.dataset.nextdevUgcInit = '1';


    var viewport = root.querySelector('[data-nextdev-ugc-viewport]');
    var track = root.querySelector('[data-nextdev-ugc-track]');
    var dotsBox = root.querySelector('[data-nextdev-ugc-dots]');
    var prevBtn = root.querySelector('[data-nextdev-ugc-prev]');
    var nextBtn = root.querySelector('[data-nextdev-ugc-next]');
    if (!viewport || !track) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var real = Array.prototype.slice.call(track.querySelectorAll('[data-nextdev-ugc-slide]'));
    var count = real.length;
    if (!count) return;

    // the middle copy holds the real slides, the two outer copies are there
    // to be looked at while the loop resets
    var head = document.createDocumentFragment();
    var tail = document.createDocumentFragment();
    real.forEach(function (slide) {
      head.appendChild(slide.cloneNode(true));
      tail.appendChild(slide.cloneNode(true));
    });
    track.insertBefore(head, track.firstChild);
    track.appendChild(tail);

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-nextdev-ugc-slide]'));
    var index = count;
    var slideWidth = 0;
    var gap = 0;
    var stepWidth = 0;
    var innerWidth = 0;

    function readNumber(name, fallback) {
      var value = parseFloat(getComputedStyle(root).getPropertyValue(name));
      return isNaN(value) ? fallback : value;
    }

    // how many slides fit at once, and the gap between them. Mobile shows one
    // and a half, desktop grows with the width and stops at three and a half.
    function measure() {
      var styles = getComputedStyle(viewport);
      innerWidth = viewport.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      var perView, spacing;
      if (window.innerWidth <= 749) {
        perView = 1.5;
        spacing = 12;
      } else {
        perView = Math.min(3.5, Math.max(2.5, innerWidth / 330));
        spacing = 18 + (perView - 2.5) * 4;
      }
      gap = Math.round(spacing);
      slideWidth = (innerWidth - gap * (perView - 1)) / perView;
      stepWidth = slideWidth + gap;
      root.style.setProperty('--nextdev-ugc-slide-width', slideWidth.toFixed(2) + 'px');
      root.style.setProperty('--nextdev-ugc-gap', gap + 'px');
    }

    function offsetFor(i) {
      return innerWidth / 2 - (i * stepWidth + slideWidth / 2);
    }

    // a slide that is cut off by the edge of the viewport is dimmed, the ones
    // fully in view stay at full strength. The ratio is worked out from the
    // geometry, so it is right even before the move has finished.
    function paint(offset) {
      var peek = readNumber('--nextdev-ugc-peek', .5);
      for (var i = 0; i < slides.length; i++) {
        var left = offset + i * stepWidth;
        var shown = Math.min(left + slideWidth, innerWidth) - Math.max(left, 0);
        var ratio = slideWidth ? shown / slideWidth : 0;
        slides[i].style.setProperty('--nextdev-ugc-slide-opacity', ratio >= 0.97 ? '1' : String(peek));
      }
    }

    function markActive() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('nextdev--ugc__slide--active', i === index);
      });
      if (dotsBox) {
        var current = ((index % count) + count) % count;
        Array.prototype.forEach.call(dotsBox.children, function (dot, i) {
          dot.classList.toggle('nextdev--ugc__dot--active', i === current);
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }
    }

    function place(offset) {
      root.style.setProperty('--nextdev-ugc-x', offset.toFixed(2) + 'px');
      paint(offset);
    }

    function jump(offset) {
      track.classList.add('nextdev--ugc__track--dragging');
      place(offset);
      void track.offsetHeight;
      track.classList.remove('nextdev--ugc__track--dragging');
    }

    // after a move the index is pulled back into the middle copy, so there is
    // always a full set of slides on either side
    function normalise() {
      if (index >= count && index < count * 2) return;
      index = count + (((index % count) + count) % count);
      jump(offsetFor(index));
    }

    function goTo(i) {
      index = i;
      place(offsetFor(index));
      markActive();
      // with motion turned off there is no transition to wait for
      if (reduced) normalise();
    }

    function step(direction) {
      goTo(index + direction);
    }

    // only the track's own move counts, the frames inside it animate too
    track.addEventListener('transitionend', function (event) {
      if (event.target === track && event.propertyName === 'transform') normalise();
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    // ---- dots, one per real slide ----
    if (dotsBox) {
      real.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nextdev--ugc__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(count + i); });
        dotsBox.appendChild(dot);
      });
    }

    // ---- drag with the pointer, on the trackpad and on touch ----
    // The pointer is only captured once it has actually travelled, so a plain
    // click still reaches the button it landed on.
    var pressed = false;
    var dragging = false;
    var startX = 0;
    var startOffset = 0;
    var moved = 0;
    var pointerId = null;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      // the video keeps its own controls, everything else can be dragged
      if (event.target.closest('video')) return;
      pressed = true;
      dragging = false;
      moved = 0;
      pointerId = event.pointerId;
      startX = event.clientX;
      startOffset = offsetFor(index);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!pressed) return;
      moved = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(moved) < 4) return;
        dragging = true;
        track.classList.add('nextdev--ugc__track--dragging');
        viewport.classList.add('nextdev--ugc__viewport--dragging');
        viewport.setPointerCapture(pointerId);
      }
      place(startOffset + moved);
    });

    function endDrag() {
      if (!pressed) return;
      pressed = false;
      if (!dragging) {
        pointerId = null;
        return;
      }
      dragging = false;
      track.classList.remove('nextdev--ugc__track--dragging');
      viewport.classList.remove('nextdev--ugc__viewport--dragging');
      if (pointerId !== null && viewport.hasPointerCapture(pointerId)) {
        viewport.releasePointerCapture(pointerId);
      }
      pointerId = null;

      var slid = -moved / stepWidth;
      var jumped = 0;
      if (Math.abs(slid) > 0.15) {
        jumped = slid > 0 ? Math.max(1, Math.round(slid)) : Math.min(-1, Math.round(slid));
      }
      goTo(index + jumped);
      if (!jumped) normalise();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });

    // ---- the videos load only once someone asks for them ----
    track.addEventListener('click', function (event) {
      var button = event.target.closest('[data-nextdev-ugc-play]');
      if (!button) return;
      // a drag that happens to start on the button is not a click on it
      if (Math.abs(moved) > 6) return;

      var frame = button.closest('.nextdev--ugc__frame');
      var image = frame.querySelector('.nextdev--ugc__image');
      root.querySelectorAll('.nextdev--ugc__video').forEach(function (playing) { playing.pause(); });

      var video = document.createElement('video');
      video.className = 'nextdev--ugc__video';
      video.src = button.getAttribute('data-video');
      video.poster = image ? image.getAttribute('src') : '';
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      frame.appendChild(video);
      frame.classList.add('nextdev--ugc__frame--playing');
      button.remove();
      if (image) image.remove();
    });

    // ---- the counter runs once, when the section comes into view ----
    var counter = root.querySelector('[data-nextdev-ugc-count]');
    if (counter) {
      var target = parseInt(counter.getAttribute('data-nextdev-ugc-count'), 10) || 0;
      var suffix = counter.getAttribute('data-nextdev-ugc-suffix') || '';
      // the number is grouped here, so the theme can print it plain
      counter.textContent = target.toLocaleString('en-US') + suffix;
    }
    if (counter && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, observer) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        if (reduced) return;
        var startedAt = performance.now();
        var duration = 1600;
        requestAnimationFrame(function frame(now) {
          var progress = Math.min((now - startedAt) / duration, 1);
          var value = Math.round(target * (1 - Math.pow(1 - progress, 3)));
          counter.textContent = value.toLocaleString('en-US') + (progress === 1 ? suffix : '');
          if (progress < 1) requestAnimationFrame(frame);
        });
      }, { threshold: 0.5 }).observe(counter);
    }

    // ---- start, and follow the width ----
    function layout() {
      measure();
      jump(offsetFor(index));
      markActive();
    }

    layout();
    window.addEventListener('load', layout);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    });
  }

  function start() {
    document.querySelectorAll('[data-nextdev-ugc]').forEach(setup);
  }

  start();
  document.addEventListener('shopify:section:load', start);
})();